import store from "@/store";
import lodash from "lodash";
import EmojiDecoder from "@/utils/emoji/EmojiDecoder";
import { errorMessage, successMessage } from "./message";
import Clipboard from "vue-clipboard3";
import { v4 as uuidv4 } from 'uuid';
import { createSession } from "./http/chat/chat";
export function initEmoji() {
  let emoji = {
    url: store.state.systemConfig.fileUrl,
    map: store.state.emojiList,
    visible: false,
    decoder: new EmojiDecoder(
      store.state.systemConfig.fileUrl,
      store.state.emojiList
    ),
  };
  return emoji;
}
export function getUuidV4() {
  return uuidv4().replace(/-/g, '');
}

export function chatMsgfindTime(data: any) {
  let time = 0;
  for (var i = 0; i < data.length; i++) {
    if (i == 0) {
      data[i].showTime = true;
      time = data[i].createTime;
    } else {
      let d = (data[i].createTime - time) / 1000;
      let tt = parseInt(d + "");
      if (tt > 300) {
        data[i].showTime = true;
        time = data[i].createTime;
      } else data[i].showTime = false;
    }
  }
  return data;
}
export function DateTimeFormat(dateTime: any, formatStr = "yyyy.mm.dd  h:M") {
  let date;
  // 若传入时间为假值，则取当前时间
  if (!dateTime) {
    date = new Date();
  }
  // 若为unix秒时间戳，则转为毫秒时间戳（逻辑有点奇怪，但不敢改，以保证历史兼容）
  else if (/^\d{10}$/.test(dateTime?.toString().trim())) {
    date = new Date(dateTime * 1000);
  }
  // 若用户传入字符串格式时间戳，new Date无法解析，需做兼容
  else if (typeof dateTime === "string" && /^\d+$/.test(dateTime.trim())) {
    date = new Date(Number(dateTime));
  }
  // 处理平台性差异，在Safari/Webkit中，new Date仅支持/作为分割符的字符串时间
  // 处理 '2022-07-10 01:02:03'，跳过 '2022-07-10T01:02:03'
  else if (
    typeof dateTime === "string" &&
    dateTime.includes("-") &&
    !dateTime.includes("T")
  ) {
    date = new Date(dateTime.replace(/-/g, "/"));
  }
  // 其他都认为符合 RFC 2822 规范
  else {
    date = new Date(dateTime);
  }

  const timeSource: any = {
    y: date.getFullYear().toString(), // 年
    m: (date.getMonth() + 1).toString().padStart(2, "0"), // 月
    mm: (date.getMonth() + 1).toString().padStart(2, "0"), // 月
    d: date.getDate().toString().padStart(2, "0"), // 日
    dd: date.getDate().toString().padStart(2, "0"), // 日
    h: date.getHours().toString().padStart(2, "0"), // 时
    M: date.getMinutes().toString().padStart(2, "0"), // 分
    s: date.getSeconds().toString().padStart(2, "0"), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  //判断222
  for (const key in timeSource) {
    const [ret] = new RegExp(`${key}+`).exec(formatStr) || [];
    if (ret) {
      // 年可能只需展示两位
      const beginIndex = key === "y" && ret.length === 2 ? 2 : 0;
      formatStr = formatStr.replace(ret, timeSource[key].slice(beginIndex));
    }
  }

  return formatStr;
}

/**
 * 距当前时间点的时长
 * @prama time 13位时间戳
 * @return str x秒 / x分钟 / x小时
 */
export function formateTime(timestamp: any) {
  if (timestamp == null) timestamp = Number(new Date());
  timestamp = parseInt(timestamp);
  // 判断用户输入的时间戳是秒还是毫秒,一般前端js获取的时间戳是毫秒(13位),后端传过来的为秒(10位)
  if (timestamp.toString().length == 10) timestamp *= 1000;
  let timer: number = (new Date().getTime() - timestamp) / 1000;
  // 如果小于5分钟,则返回"刚刚",其他以此类推
  let tips = "";
  switch (true) {
    case timer < 60 * 5:
      tips = "刚刚";
      break;
    case timer >= 60 * 5 && timer < 60 * 60:
      let dd = parseInt(timer / 60 + "");
      tips = `${dd}分钟前`;
      break;
    case timer >= 60 * 60 && timer < 60 * 60 * 12:
      tips = DateTimeFormat(timestamp, "hh:M");
      break;
    default:
      tips = DateTimeFormat(timestamp, "m月dd日 hh:M");
  }
  return tips;
}
export function formateTimeList(timestamp: any) {
  if (timestamp == null) timestamp = Number(new Date());
  timestamp = parseInt(timestamp);
  // 判断用户输入的时间戳是秒还是毫秒,一般前端js获取的时间戳是毫秒(13位),后端传过来的为秒(10位)
  if (timestamp.toString().length == 10) timestamp *= 1000;
  let timer: number = (new Date().getTime() - timestamp) / 1000;
  // 如果小于5分钟,则返回"刚刚",其他以此类推
  let tips = "";
  switch (true) {
    case timer < 60 * 5:
      tips = "刚刚";
      break;
    case timer >= 60 * 5 && timer < 60 * 60:
      let dd = parseInt(timer / 60 + "");
      tips = `${dd}分钟前`;
      break;
    case timer >= 60 * 60 && timer < 60 * 60 * 12:
      tips = DateTimeFormat(timestamp, "hh:M");
      break;
    default:
      tips = DateTimeFormat(timestamp, "m/dd");
  }
  return tips;
}
export function formatHead(head: any) {
  if (head) {
    if (head.substring(0, 4) === "http" || head.substring(0, 5) === "https") {
      return head;
    } else {
      return store.state.systemConfig.fileUrl + head;
    }
  } else {
    return store.state.systemConfig.fileUrl + store.state.systemConfig.head;
  }
}
export function formatPhone(phone: any) {
    if (!phone) return;
    if (phone.length === 11) {
        // 通常手机号码长度为11位
        return phone.substring(0, 3) + "****" + phone.substring(7);
    } else {
        return phone; // 如果不是11位，直接返回原号码
    }
}
export function formatSalary(min: any, max: any, fmt?: any) {
  if (!min && !max) return "面议";
  if (!min) {
    if (fmt === "k") return max / 1000 + "k";
    else return max;
  }
  if (!max) {
    if (fmt === "k") return min / 1000 + "k";
    else return min;
  }
  if (min && max) {
    if (min === max) {
      if (fmt === "k") return max / 1000 + "k";
      else return max;
    } else {
      if (fmt === "k") return min / 1000 + "k-" + max / 1000 + "k";
      else return min + "-" + max;
    }
  }
}
export function formatJobTitle(item: any) {
  if (!item.careerTitle) return item.remarks;
  if (!item.areaTitle)
    return "招" + item.careerTitle + (item.remarks ? "，" + item.remarks : "");
  let arr = item.areaTitle.split("-");
  let arry = lodash.takeRight(arr, 2);
  let title = arry.join("");
  if (title) {
    title +=
      "招" + item.careerTitle + (item.remarks ? "，" + item.remarks : "");
  } else {
    title += item.careerTitle + (item.remarks ? "，" + item.remarks : "");
  }
  return title;
}
export function formatJobTitleTwo(item: any) {
  if (!item.areaTitle) return "招" + item.careerTitle;
  let arr = item.areaTitle.split("-");
  let arry = lodash.takeRight(arr, 2);
  let title = arry.join("");
  if (title) {
    title += "招" + item.careerTitle;
  } else {
    title += item.careerTitle;
  }
  return title;
}

export function areaTocity(areaTitle: any, num?: any, str?: any) {
  if (!areaTitle) return "";
  if (!num) num = 3;
  if (!str) str = "";
  let arr = areaTitle.split("-");
  let arry = lodash.take(arr, num);
  let title = arry.join(str);
  return title;
}
export function uniqAreaFormat(item: any) {
  if (!item) return "";
  let arr = item.split("-");
  let newArr = lodash.uniq(arr);
  return newArr.join("");
}
export function oneAreaFormat(areaTitle: any) {
  if (!areaTitle) return "";
  let arr = areaTitle.split("-");
  if (arr.length < 3) {
    let newStr = lodash.takeRight(arr, 1);
    return newStr.join("");
  } else {
    return arr[1];
  }
}
export async function copyText(text: any) {
  const { toClipboard } = Clipboard();
  try {
    await toClipboard(text);
    successMessage("复制成功");
  } catch (e) {
    console.error(e);
    errorMessage("复制失败");
  }

  // if(!text) return errorMessage("复制失败，内容为空")
  // if (XEClipboard.copy(text)) {
  //     successMessage("已复制到剪贴板！")
  // }else{
  //     errorMessage("复制失败")
  // }
}
//地址级联搜索
export const areaSelect = (node: any, val: String) => {
  let pingyin = node.data.pinyin.replace(new RegExp(/( )/g), "");
  let pinyinPrefix = node.data.pinyinPrefix.replace(new RegExp(/( )/g), "");
  if (
    node.data.extName.includes(val) ||
    node.data.code.includes(val) ||
    node.data.title.includes(val) ||
    pingyin.includes(val) ||
    pingyin.toUpperCase().includes(val) ||
    pinyinPrefix.includes(val) ||
    pinyinPrefix.replace(new RegExp(/( )/g), "").toUpperCase().includes(val)
  )
    return true;
  return false;
};

//打招呼
export const chatFirstMsg = (id: any, jobId: any) => {
  return new Promise((resolve) => {
    createSession({ 
        memberId: id,
        type:1,
        sendStatus:true,
        jobId: (jobId && jobId != 0) ? jobId:''
    }).then((resone: any)=>{
        if (resone.status != 200 || !resone.data.sessionInfo) return resolve(false);
        return resolve(true);
    }) 
  });
};

export const parseMsgModel = (item:any) =>{
    let contents: any = []
    let content = {
        code:'',
		title:'',
		content:'',
		subTitle:'',
        icon:'',
        linkText:'',
        linkType:'',
		path:''
	};
    
    if (!item) return contents
    let p = JSON.parse(item);
    content.code = p.hasOwnProperty("code") ? p.code:'',
	content.title = p.hasOwnProperty("title") ? p.title:'',
	content.content = p.hasOwnProperty("content") ? p.content:'',
	content.subTitle = p.hasOwnProperty("subTitle") ? p.subTitle:'',
    content.icon = p.hasOwnProperty("icon") ? p.icon:'',
    content.linkText = p.hasOwnProperty("linkText") ? p.linkText:'',
    content.linkType = p.hasOwnProperty("linkType") ? p.linkType:'',
	content.path = p.hasOwnProperty("path") ? p.path:''
    contents.push(content)
	return contents;
}

